import { supabase } from './supabaseClient';

export const PO_STATUSES = ['Ordered', 'Shipped', 'Received', 'Cancelled'];

export async function listPurchaseOrders() {
  const { data, error } = await supabase
    .from('purchase_orders')
    .select('*, vendor:vendors(id, name), purchase_order_items(*)')
    .order('order_date', { ascending: false });
  if (error) throw error;
  return data;
}

export async function addPurchaseOrder(po, items) {
  const { data: poRow, error: poError } = await supabase
    .from('purchase_orders')
    .insert(po)
    .select('*, vendor:vendors(id, name)')
    .single();
  if (poError) throw poError;

  await insertItems(poRow.id, items);
  return poRow;
}

export async function updatePurchaseOrder(id, po, items) {
  const { error: poError } = await supabase.from('purchase_orders').update(po).eq('id', id);
  if (poError) throw poError;

  const { error: deleteError } = await supabase
    .from('purchase_order_items')
    .delete()
    .eq('purchase_order_id', id);
  if (deleteError) throw deleteError;

  await insertItems(id, items);
}

async function insertItems(purchaseOrderId, items) {
  const rows = items.map((item, index) => ({
    purchase_order_id: purchaseOrderId,
    sort_order: index,
    item_name: item.item_name,
    quantity: item.quantity,
    unit_cost: item.unit_cost,
    notes: item.notes || null,
  }));
  const { error } = await supabase.from('purchase_order_items').insert(rows);
  if (error) throw error;
}

export async function listPurchaseOrdersByVendor(vendorId) {
  const { data, error } = await supabase
    .from('purchase_orders')
    .select('*, purchase_order_items(*)')
    .eq('vendor_id', vendorId)
    .order('order_date', { ascending: false });
  if (error) throw error;
  return data;
}

export async function setPurchaseOrderStatus(id, status, extra = {}) {
  const { error } = await supabase
    .from('purchase_orders')
    .update({ status, ...extra })
    .eq('id', id);
  if (error) throw error;
}

export async function deletePurchaseOrder(id) {
  const { error } = await supabase.from('purchase_orders').delete().eq('id', id);
  if (error) throw error;
}

export function lineTotal(item) {
  return Number(item.quantity || 0) * Number(item.unit_cost || 0);
}

export function poSubtotal(items) {
  return items.reduce((sum, item) => sum + lineTotal(item), 0);
}

export function poTotalJmd(items, exchangeRate) {
  return poSubtotal(items) * Number(exchangeRate || 1);
}
